<template>
  <div class="content">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>课程待办</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/classservice/class' }">课程待办管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="button-wrap">
        <el-button size="small"
                   type="primary"
                   @click="handleToLog()">新建</el-button>
      </div>
    </div>

    <el-card style="margin-top: 20px">
      <div class="card-header">
        <TableTittle :title="TableName"></TableTittle>
        <el-form label-width="70px"
                 size="small"
                 style="margin-bottom:0px;display:flex;"
                 label-position="right">
          <el-form-item label-width="32px">
            <el-radio-group v-model="query.statuses"
                            @change="fetchList(true)">
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button :label="1">上架</el-radio-button>
              <el-radio-button :label="0">下架</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <el-table :data="result"
                :header-cell-style="{
          textAlign: 'center',
          color: '#909399',
          fontFamily: 'PingFang SC',
          fontSize: '14px',
          fontWeight: '400',
          backgroundColor: '#F2F6FC',
        }"
                :cell-style="{ fontSize: '13px' }"
                @selection-change="handleSelectionChange"
                border>
        <el-table-column type="selection"
                         width="50"
                         align="center">
        </el-table-column>
        <el-table-column label="序号"
                         width="80"
                         type="index"
                         align="center">
        </el-table-column>
        <el-table-column label="待办名称"
                         width="500"
                         align="left"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.todo_name }}

          </template>
        </el-table-column>
        <el-table-column label="状态"
                         width="90"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1"
                    size="mini"
                    type="success">上架</el-tag>
            <el-tag v-if="scope.row.status == 0"
                    type="danger"
                    size="mini">下架</el-tag>

          </template>
        </el-table-column>

        <el-table-column label="创建人"
                         width="100"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.creator_nickname }}

          </template>
        </el-table-column>
        <el-table-column label="开始时间"
                         align="center"
                         width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.start_time_type==1">
              {{
              scope.row.start_time_fix_point
                ? $moment(scope.row.start_time_fix_point).format("YYYY-MM-DD HH:mm")
                : ""
            }}
            </span>
            <span v-else>{{getTime(scope.row.start_time_active_duration)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="截止时间"
                         align="center"
                         width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.end_time_type==1">
              {{
              scope.row.end_time_fix_point
                ? $moment(scope.row.end_time_fix_point).format("YYYY-MM-DD HH:mm")
                : ""
            }}
            </span>
            <span v-else>
              {{getTime(scope.row.end_time_active_duration)}}

            </span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间"
                         align="center"
                         width="250">
          <template slot-scope="scope">
            {{
              scope.row.create_time
                ? $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm")
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column label="修改时间"
                         align="center"
                         width="250">
          <template slot-scope="scope">
            {{
              scope.row.update_time
                ? $moment(scope.row.update_time).format("YYYY-MM-DD HH:mm")
                : ""
            }}
          </template>
        </el-table-column>

        <el-table-column prop="name"
                         label="操作"
                         width="200"
                         align="center"
                         fixed="right">
          <template slot-scope="scope">
            <div class="templateLink">
              <el-link type="primary"
                       :underline="false"
                       @click="handleToEdit(scope.row)">编辑</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 16px">
        <el-button size="mini"
                   type="danger"
                   @click="handleToDeleteAll()">批量删除</el-button>
        <div class="block">
          <el-pagination background
                         layout="total, prev, pager, next, sizes, jumper"
                         :current-page="Number(query.pageIndex)"
                         :page-sizes="[10, 20, 50, 100, 500]"
                         :page-size="Number(query.pageSize)"
                         :total="Number(pageTotal)"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"></el-pagination>
        </div>
      </div>
    </el-card>
    <AddToDoCourse :isVisible="addVisible"
                   @close="addClose"
                   @submit="fetchList()"
                   :title="title"
                   :courseId="courseId"
                   :detail="detail"> </AddToDoCourse>
  </div>
</template>
  
  <script>
import TableTittle from '../../../components/TableTittle/TableTittle.vue'
import AddToDoCourse from '@/components/DialogComponents/ClassService/AddToDoCourse'
import {
  courseList,
  courseDelete,
  courseTodoList,
  courseTodoDelete,
} from '@/request/api'

export default {
  components: {
    TableTittle,
    AddToDoCourse,
  },
  data() {
    return {
      TableName: '课程待办列表',
      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
        statuses: 1,
      },
      result: [],
      chooseList: [],
      addVisible: false,
      pageTotal: 0,
      title: '',
      detail: {},
      courseId: null,
    }
  },
  created() {
    this.fetchList()
  },

  computed: {},
  methods: {
    fetchList(isReset = false) {
      const params = Object.assign({}, this.query)
      if (isReset == true) {
        this.query.pageIndex = 1
      }
      params.course_id = this.$route.params.id
      courseTodoList(params).then((response) => {
        let res = response.data
        this.result = res.data.list || []
        this.pageTotal = res.data.count
      })
    },
    getTime(time) {
      const seconds = time / 1000
      const days = Math.floor(seconds / 86400)
      const hours = Math.floor((seconds % 86400) / 3600)
      let parts = []
      if (days > 0) parts.push(`${days}天`)
      parts.push(`${hours}小时`)
      return parts.join(' ')
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    handleToLog() {
      this.title = '新建'
      this.courseId = this.$route.params.id * 1
      this.addVisible = true
    },
    handleToEdit(row) {
      this.detail = row
      this.title = '编辑'
      this.courseId = this.$route.params.id * 1
      this.addVisible = true
    },
    addClose() {
      this.addVisible = false
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.fetchList()
    },
    handleCurrentChange(val) {
      this.query.pageIndex = val
      this.fetchList()
    },
    handleToDeleteAll() {
      if (this.chooseList.length == 0) {
        this.$message.error('至少选择一条数据！')
        return
      }

      this.$confirm('确定要删除此条信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then((res) => {
        console.log('this.chooseList', this.chooseList)
        let ids = []
        this.chooseList.map((item) => {
          ids.push(item.id)
        })
        console.log('ids', ids)
        courseTodoDelete({ ids }).then((res) => {
          if (res.data.code == 0) {
            this.$message.success('删除成功')
            this.fetchList()
          }
        })
      })
    },
  },
}
</script>
  
  <style lang="less" scoped>
.img-list {
  margin-top: 12px;
  display: flex;
  align-items: center;

  img {
    width: 140px;
    height: 140px;
    margin-right: 12px;
    border-radius: 4px;
  }
}
.dropdown-item {
  height: 100%;
  width: 100%;
}
/deep/.el-badge__content {
  z-index: 999999;
}
.count-wrap {
  padding: 30px 0px;
  background: #ecf2fe;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    .label {
      margin-bottom: 12px;
    }
    .value {
      font-size: 28px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    .red {
      color: #f36d78;
    }
  }
}
</style>
  